<template>
	<v-container fluid class="mx-0 px-0">
		<v-tabs v-model="tab" class="mb-4" color="primary">
			<v-tab
				key="searchFilters"
				href="#searchFilters"
				style="font-size: 16px"
				aria-label="Nova Pesquisa"
			>
				<v-icon dense class="mr-2">
					fas fa-search
				</v-icon>
				Nova Pesquisa
			</v-tab>
		</v-tabs>

		<v-tabs-items
			style="border-radius: 5px"
			v-model="tab"
			grow>
			<v-tab-item key="searchFilters" value="searchFilters">
				<v-row v-show="!overlay" class="mt-2 foreground--text">
					<v-col cols="12" sm="6" md="4" lg="3" class="py-0">
						<label>Grupo Financeiro</label>
						<v-autocomplete
							v-model="filterMyReports.financialGroupId"
							class="mt-1"
							placeholder="Selecione"
							item-text="name"
							item-value="id"
							outlined
							dense
							color="primary"
							item-color="primary"
							:items="financialGroups"
							:search-input.sync="financialGroupIdSearch"
              @change="financialGroupIdSearch = null"
						/>
					</v-col>
					<v-col cols="12" sm="6" md="4" lg="3" class="py-0">
						<label>Layout de Relatório</label>
						<v-autocomplete
							v-model="filterMyReports.reportLayout"
							class="mt-1"
							placeholder="Selecione"
							item-text="name"
							item-value="id"
							outlined
							dense
							color="primary"
							item-color="primary"
							:items="getReportLayoutTypesFilter"
							:search-input.sync="reportLayoutSearch"
              @change="reportLayoutSearch = null"
						/>
					</v-col>
					<v-col cols="12" sm="6" md="4" lg="3" class="py-0">
						<label>Status</label>
						<v-autocomplete
							v-model="filterMyReports.status"
							class="mt-1"
							placeholder="Selecione"
							item-text="name"
							item-value="id"
							outlined
							dense
							color="primary"
							item-color="primary"
							:items="myReportsStatusFilter"
							:search-input.sync="statusSearch"
              @change="statusSearch = null"
						/>
					</v-col>
				</v-row>
				<v-row v-show="overlay" class="primary--text my-15">
					<v-col cols="12" class="d-flex justify-center">
						<v-progress-circular
							color="primary"
							indeterminate
							size="64"
							width="8"
						/>
					</v-col>
					<v-col cols="12" class="d-flex justify-center"> Carregando Filtros </v-col>
				</v-row>
			</v-tab-item>
		</v-tabs-items>
	</v-container>
</template>

<script>
import MovementRecordsMixin from "@/shared/mixins/movementRecords/movementRecordsMixin";
import MyReportsMixin from "@/shared/mixins/myReports/myReportsMixin"

export default {
	name: "MyReportsContentFilter",

	data: () => ({
		statusSearch: null,
		reportLayoutSearch: null,
		financialGroupIdSearch: null,
		overlay: false,
		tab: "searchFilters",
		changeTabValue: "FILE_DATA"
	}),

	mixins: [ MovementRecordsMixin, MyReportsMixin ],

	props: {
		financialGroups: {
			type: Array,
			default: () => []
		},
		resetFilterMyReports: {
			type: Boolean,
			default: false
		},
		isRHProtegido: {
			type: Boolean,
			default: false
		}
	},

	watch: {
		filterMyReports: {
			deep: true,
			immediate: true,
			handler(value) {
				if (value) this.$emit("hasFiltersMyReports", this.filterMyReports)
			}
		},
		resetFilterMyReports: {
			deep: true,
			handler(value) {
				if (value) this.clearFilterMyReports()
			}
		}
	},

	methods: {
		// clears the page filters object
		clearFilterMyReports() {
			this.filterMyReports = {
				financialGroupId: '',
				reportLayout: '',
				status: '',
				receivingDateStart: '',
				receivingDateEnd: '',
			}
			this.$forceUpdate()
			this.$emit("resetStatusFilters", false)
		},
	},
}
</script>
